import { ConexionCompleta } from "@victorequena22/conneccion";

class CotizacionConexion extends ConexionCompleta {
    clase = 'Cotizacion';
    persistencia = 1000;
}
export default function conCotizacion() {
    return new CotizacionConexion();
}